import { useEffect } from "react";
import { useAdvanceSearchContext } from "./AdvanceSearchContextTest";

import { Tabs } from "react-bootstrap";
import { Tab } from "bootstrap";
import ResultTab from "./ResultTab";
import Heading from "./Heading";
import SearchTab from "./SearchTab";
import Pagination from "../../../components/Pagination";
import "./inputs.css";
import "./AdvanceSearch.scss";
import MySearches from "./MySearches";
import { useGeneralContext } from "../../General/Context";
import SmartSearchTab from "./SmartSearch/SmartSearchTab";

function InterviewAdvanceSearchTest() {
  const {
    activeTab,
    setActiveTab,
    t,
    totalpages,
    setPageNumber,
    pageNumber,
    setPageSize,
    storedSearch
  } = useAdvanceSearchContext();
  const { userInformation } = useGeneralContext();

  useEffect(() => (document.title = t("AtVitae - Advanced Search")), [t]);

  return (
    <div>
      <Heading />
      <div className="row">
        <div>
          <Tabs
            defaultActiveKey="search"
            activeKey={activeTab}
            onSelect={(tab) => setActiveTab(tab)}
            id="advanceSearch"
            className="mb-3 tab-width-search-result"
            fill
          >
            <Tab eventKey="smartSearch" title={t("SmartSearch")}>
              <SmartSearchTab />
            </Tab>

            <Tab eventKey="search" title={t("Search")}>
              <SearchTab />
            </Tab>
            <Tab eventKey="mySearches" title={t("My Searches")}>
              <MySearches />
            </Tab>
            <Tab eventKey="searchResults" title={t("Result")}>
              <ResultTab />
            </Tab>
          </Tabs>
        </div>
      </div>
      <div className="row">
        <div>
          {activeTab === "searchResults" && (
            <Pagination
              totalPages={totalpages}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
              numberOfButtons={3}
              setPageSize={setPageSize}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default InterviewAdvanceSearchTest;
